import React from "react";
import IChRobinsonQuoteSummaryItem from "../../../../models/IChRobinsonQuoteSummaryItem";
import OwButton from "../../OwButton/OwButton";
import OwLabel from "../../OwLabel/OwLabel";
import { FormattedNumber } from "react-intl";
import { ChRobinsonRatesModalListViewLine } from "./ChRobinsonRatesModalListViewLine/ChRobinsonRatesModalListViewLine";
import IOrder from "../../../../models/IOrder";

type Props = {
    items: IChRobinsonQuoteSummaryItem[];
    selectedIndex?: number;
    selectRatingRequstIndex: (index: number) => void;
    saveSelected: () => void;
    restart: () => void;
    order: IOrder;
    active: boolean;
};

export const ChRobinsonRatesModalListView = (props: Props) => {
    let previouslySelected = false;

    if (props.order.Order_Detail?.chrobinson_rate_detail) {
        if (props.items.find((item) => item.quoteId === props.order.Order_Detail?.chrobinson_rate_detail?.quoteId)) {
            previouslySelected = true;
        }
    }

    return (
        <div className={"ChRobinsonRatesModalListView"}>
            <div className={"d-flex font-weight-bold p-2"}>
                <div className={"w-25"}>
                    <OwLabel title={"carrier"} />
                </div>
                <div className={"w-25"}></div>
                <div className={"w-25"}>
                    <OwLabel title={"mode"} />
                </div>
                <div className={"w-25 text-end"}>
                    <OwLabel title={"price"} />
                </div>
            </div>
            <div className={"d-flex"}>
                {props.items.map((item, index) => {
                    return (
                        <ChRobinsonRatesModalListViewLine
                            hideSelect={props.order.Order_Detail?.chrobinson_rate_detail?.quoteId === item.quoteId}
                            item={item}
                            key={item.quoteId}
                            index={index}
                            selectedIndex={props.selectedIndex}
                            selectRatingRequstIndex={props.selectRatingRequstIndex}
                        />
                    );
                })}
            </div>
            <div>
                {previouslySelected ? (
                    <OwButton title={"restart"} fn={props.restart} />
                ) : (
                    <div>
                        <OwButton title={"ok"} fn={props.saveSelected} disabled={props.selectedIndex === undefined} />{" "}
                        <OwButton title={"restart"} fn={props.restart} className={"btn-danger"} />
                    </div>
                )}
            </div>
        </div>
    );
};
